import { DateTime } from 'luxon'
import Cookies, { CookieSetOptions } from 'universal-cookie'

const defaultOptions: CookieSetOptions = {
  path: '/',
  expires: DateTime.local().plus({ year: 1 }).toJSDate(),
}

let cookie = new Cookies()

function reinitialize(cookies?: string | object | null) {
  cookie = new Cookies(cookies)
}

function setItem(key: string, value: string | null) {
  cookie.set(key, value, defaultOptions)
}

function getItem(key: string) {
  return cookie.get(key, { doNotParse: true })
}

export const CookieStorage: Storage = {
  setItem,
  getItem,
  reinitialize,
  clear: () => reinitialize({}),
  key: (index: number) => Object.keys(cookie.getAll())[index] ?? null,
  removeItem: (key: string) => cookie.remove(key, { path: '/' }),
  length: Object.keys(cookie.getAll()).length,
}
